import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';


import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import {
    Add,
    Close, 
    Check, 
    Edit
} from 'material-ui-icons';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';

import axios from 'axios';
import moment from 'moment-timezone';

class GifcardsList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			rowsPerPage: 50,
		    page: 0,
		    total: 0,
			data: [],
		};
	}

	componentDidMount() {
		this.loadEntities(1);
	}

	loadEntities(page) {
		axios.get('/api/operator/voucher?page=' + page + '&perPage=' + this.state.rowsPerPage)
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage = (e, page) => {
		this.loadEntities(page+1);	// paginator counts pages as indexes (starting 0)
	};

  render() {
    return (
      <div>
        <Paper>
            <div className="flex-auto">
                <div className="table-responsive-material">
                    <List>
                        {this.state.data.map((model, index) => {
                            return (<div key={model.id}>
                                <ListItem >
                                    <Grid container spacing={0}>
                                        <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                primary={<span className={(model.value > 0 ? '' : ' text-strikethrough')}>{model.code}</span>}
                                                secondary={
                                                  <div>
                                                    <i className="zmdi zmdi-account" />{' '}{model.first_name} {model.last_name}
                                                    {' '}<i className="zmdi zmdi-email" />{' '}{model.email || '-'}
                                                  </div>
                                                }
                                            />
                                        </Grid>
                                        {model.aircraft_offer ?
                                        <Grid item sm={3} xs={6}>
                                          <ListItemText className="br-break"
                                                        primary={<span className={(model.value > 0 ? '' : ' text-strikethrough')}><i className="zmdi zmdi-airplane" />{' '}{model.aircraft_offer.flight_offer.title}</span>}
                                                        secondary={<span><i className="zmdi zmdi-airline-seat-recline-extra" />{' '}{model.offer_passenger_count}</span>}
                                          />
                                        </Grid>
                                        :
                                        <Grid item sm={3} xs={6}>
                                          <ListItemText className="br-break"
                                                        primary={<span><i className="zmdi zmdi-balance-wallet" />{' '}{(+model.value).toFixed(2)} {model.currency_code}</span>}
                                                        secondary={<span><i className="zmdi zmdi-balance" />{' '}{(+model.value_purchased).toFixed(2)} {model.currency_code}</span>}
                                          />
                                        </Grid>
                                        }
                                        <Grid item sm={3} xs={6}>
                                          <ListItemText className="br-break"
                                                        primary={<span><i className="zmdi zmdi-timer-off" />{' '}{moment(model.valid_until).format('ll')}</span>}
                                                        secondary={<span><i className="zmdi zmdi-time" />{' '}{moment(model.created_at).format('ll')}</span>}
                                          />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                          <ListItemText className="br-break"
                                                secondary={
                                                  <span>
                                                    <i className="zmdi zmdi-home" />{' '}{model.address.street}, {model.address.zip_code} {model.address.city}, {model.address.state ? `${model.address.state}, `: ''} {model.address.country}
                                                  </span>
                                                }
                                          />
                                        </Grid>
                                        {
                                          model.billing_remarks &&
                                          <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                  secondary={
                                                    <span>
                                                      <i className="zmdi zmdi-info" />{' '}{model.billing_remarks}
                                                    </span>
                                                  }
                                            />
                                          </Grid>
                                        }
                                    </Grid>
                                </ListItem>
                                <Divider light />
                            </div>
                            );
                        }, this)}

                    </List>

                    <Table className="">
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.state.total}
                                    rowsPerPage={this.state.rowsPerPage}
                                    rowsPerPageOptions={[this.state.rowsPerPage]}
                                    page={this.state.page-1}
                                    onChangePage={this.handleChangePage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </div>
        </Paper>
      </div>
      );
  }
}

export default GifcardsList;


// WEBPACK FOOTER //
// ./app/used/giftcards/routes/List.js